import { createStore, createEffect, createEvent, combine } from 'effector';
import i18n from 'i18n';
import { CardsApi, type BackgroundTasksResponse } from '@shared/api/rest';

const getBackgroundTasksEffect = createEffect((taskId: string) => CardsApi.backgroundTasks(taskId));
const clearEvent = createEvent();

const $dataStore = createStore<BackgroundTasksResponse | null>(null)
  .on(getBackgroundTasksEffect.done, (_, data) => data.result?.data || null)
  .reset(clearEvent);

const $loadingStore = createStore<boolean>(true)
  .on(getBackgroundTasksEffect.pending, (_, data) => data)
  .on(getBackgroundTasksEffect.fail, () => false)
  .on(getBackgroundTasksEffect.done, () => false)
  .reset(clearEvent);

const $errorStore = createStore<string | null>(null)
  .on(getBackgroundTasksEffect, () => null)
  .on(getBackgroundTasksEffect.fail, (_, data) => i18n.t(`errors.api.${data.error.message}`, data.error.message))
  .on(getBackgroundTasksEffect.done, () => null)
  .reset(clearEvent);

export const $backgroundTasksStore = {
  events: {
    getBackgroundTasks: getBackgroundTasksEffect,
    clear: clearEvent,
  },
  store: combine({
    loading: $loadingStore,
    data: $dataStore,
    error: $errorStore,
  }),
};
